import React from 'react';
import { HyperButtonLink } from '@noths/polaris-client-ribbons-design-system';
import Head from 'next/head';

import * as styles from './styles';

export const NotFound = () => (
  <div css={styles.wrapper}>
    <Head>
      <title>Page not found</title>
    </Head>
    <h1>We can&lsquo;t find the page you&lsquo;re looking for.</h1>
    <h2 css={styles.subheading}>It may have been moved, taken down or entered incorrectly.</h2>
    <HyperButtonLink href="/">Go to homepage</HyperButtonLink>
  </div>
);
